"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var ui_components_2 = require("@l2p/ui-components");
var YouParticipate_1 = __importDefault(require("../../YouParticipate"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var swr_hooks_2 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var next_intl_1 = require("next-intl");
var TournamentBlock = function (_a) {
    var _b;
    var endDate = _a.endDate, id = _a.id, baseTournament = _a.baseTournament, me = _a.me, _c = _a.withImage, withImage = _c === void 0 ? true : _c, Banner = _a.Banner;
    var _d = (0, swr_hooks_1.useJoinTournament)(), joinTournament = _d.joinTournament, isSubmitting = _d.isSubmitting;
    var isAuth = (0, swr_hooks_2.useIsAuthorized)();
    var signUpNavigate = (0, apps_shared_1.useOpenSignUp)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var router = (0, navigation_1.useRouter)();
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var participate = (0, react_1.useCallback)(function (id) {
        if (!isAuth)
            return signUpNavigate();
        if (id)
            joinTournament({ id: id });
    }, [joinTournament, signUpNavigate, isAuth]);
    var onClickHandler = (0, react_1.useCallback)(function (e) {
        if (!e.target.closest('.participate')) {
            if (baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.slug)
                router.push(generateUrlWithLang("/tournaments/".concat(baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.slug)));
        }
    }, [baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.slug, generateUrlWithLang, router]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(me ? styles_module_scss_1.default.participate : ''), onClick: onClickHandler },
        withImage ? react_1.default.createElement("img", { className: styles_module_scss_1.default.mainImg, src: "/img/tournament_placeholder.png", alt: "tournament" }) : null,
        Banner ? react_1.default.createElement(Banner, null) : null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content, style: { marginTop: withImage ? '-120px' : '0' } },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
                react_1.default.createElement("img", { src: "/img/tournaments/laurelIconLeft.svg", alt: "laurel" }),
                react_1.default.createElement("h3", null, translateLocale(baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.name)),
                react_1.default.createElement("img", { src: "/img/tournaments/laurelIconRight.svg", alt: "laurel" })),
            ((_b = baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.descriptions) === null || _b === void 0 ? void 0 : _b.short) && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("br", null),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.text, style: { height: '50px' } }, translateLocale(baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.descriptions.short)),
                react_1.default.createElement("br", null))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.timerWrapper }, endDate && (react_1.default.createElement(ui_components_1.Timer, { endDate: String(new Date(endDate)), title: t('tournamentWillFinish') }))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.participateContainer }, !me ? (react_1.default.createElement(ui_components_2.FixedButton, { color: "gradient", width: "100%", maxWidth: "100%", className: "participate", height: "60px", onClick: function () {
                    participate(id);
                }, loading: isSubmitting }, t('joinNow'))) : (react_1.default.createElement(YouParticipate_1.default, null))))));
};
exports.default = TournamentBlock;
